import { Grid } from "@material-ui/core";
import {
  InputReactDatepicker,
  Modal,
  InputTextMaster,
  MasterButton,
  InputTextArea,
} from "App/Component/ui";
import {
  convertToValidPrice,
  formatNumber,
  formatRupiah,
  pembilang,
  today,
} from "App/utils/helpers";
import { trim } from "lodash";
import React, { useState } from "react";
import { usePrintKwintansi } from "./helpers";

const RESET_STATE_KWITANSI = {
  id:"",
  tanggal: today(true),
  no_surat: "",
  penerima: "",
  untuk_pembayaran: "",
  nilai: "",
  nilai2:"",
  terbilang: "",
};

function ModalKwitansi({ setShowModal, penerima, nilai, no_surat, id, datas }) {
  const { handleClickKwintansi, loadingPrint } = usePrintKwintansi();
  const [formData, setFormData] = useState({
    ...RESET_STATE_KWITANSI,
    id,
    penerima,
    nilai,
    no_surat,
    nilai2: formatNumber(nilai),
    terbilang: trim(pembilang(Math.round(nilai))),
    untuk_pembayaran:"TAGIHAN PENGOBATAN",
    nama_virtual_account: datas?.nama_virtual_account,
    nama_bank: datas?.nama_bank,
    no_virtual_account: datas?.no_virtual_account,
  });

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal title={`Kwitansi`} show={setShowModal}>
      <form>
        <Grid container spacing={1}>
          <Grid item sm={6}>
            <InputReactDatepicker
              selected={formData.tanggal}
              label='TANGGAL'
              dateFormat='dd/MM/yyyy HH:mm'
              timeFormat='HH:mm'
              showTimeSelect
              timeIntervals={5}
              handleChangeToday={(e) =>
                setFormData({
                  ...formData,
                  tanggal: e,
                })
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tanggal: e,
                })
              }
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name='no_surat'
              label='NO SURAT KLAIM'
              id='no_surat'
              value={formData.no_surat}
              onChange={handleChange("no_surat")}
              placeholder='No Surat Klaim'
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextMaster
              name='penerima'
              label='TELAH DITERIMA DARI'
              id='penerima'
              value={formData.penerima}
              disabled={true}
              placeholder='Telah Diterima Dari'
            />
          </Grid>

          <Grid item sm={6}>
            <InputTextMaster
              name='nilai'
              label='SEBESAR'
              id='nilai'
              value={formData.nilai2}
              onChange={(e) => {
                let val = e.target.value;
                setFormData({
                  ...formData,
                  nilai: val.replaceAll(',', ''),
                  nilai2: formatRupiah(val),
                  terbilang: pembilang(Math.round(convertToValidPrice(val))),
                });
              }}
              placeholder='Sebesar'
              withButtonLeft={true}
              >
                <button
                  type={"button"}
                  onClick={null}
                  style={{
                    borderLeft: "1px solid #EAEAEA",
                    borderTop: "1px solid #EAEAEA",
                    borderBottom: "1px solid #EAEAEA",
                    borderRight: "0",
                    background: "#fff",
                    padding: "0 0 0 0.8rem",
                    cursor: "pointer",
                    borderRadius: "6px 0 0 6px",
                    fontSize: "10px",
                  }}
                >
                  Rp.
                </button>
              </InputTextMaster>
          </Grid>

          <Grid item sm={6}>
            <InputTextArea
              name='untuk_pembayaran'
              label='UNTUK PEMBAYARAN'
              id='untuk_pembayaran'
              value={formData.untuk_pembayaran}
              onChange={handleChange("untuk_pembayaran")}
              placeholder='Untuk Pembayaran'
              row={2}
            />
          </Grid>

          <Grid item sm={6}>
            <InputTextArea
              name='terbilang'
              label='TERBILANG'
              id='terbilang'
              value={formData.terbilang}
              onChange={handleChange("terbilang")}
              placeholder='Terbilang'
              row={2}
            />
          </Grid>


          <Grid
            container
            direction='row'
            justifyContent='flex-end'
            style={{
              gap: "1rem",
            }}
            alignItems='center'>
            <MasterButton
              className={"mt-1"}
              type='button'
              color={loadingPrint ? "secondary" : "green"}
              name={loadingPrint ? "Loading..." : "CETAK KWINTANSI"}
              onClick={() => loadingPrint ? null : handleClickKwintansi(formData)}
              size='md'
            />
          </Grid>
        </Grid>
      </form>
    </Modal>
  );
}

export default ModalKwitansi;

